import { useEffect, useState } from 'react';

import dayjs, { extend } from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

extend(utc);
extend(duration);
extend(relativeTime);

export function useDayJsCountdown(expiration: string, onExpired?: VoidFunction) {
    const currentTime = dayjs.utc();
    const endTime = dayjs.utc(expiration);
    const diffTime = endTime.diff(currentTime);
    const [time, setTime] = useState<number | undefined>();

    useEffect(() => {
        function countDown() {
            setTime((c) => {
                if (c) {
                    if (c <= 999) {
                        onExpired?.();
                        return diffTime;
                    }
                    const newTime = c - 1000;
                    return newTime > 1001 ? newTime : 0;
                } else {
                    return diffTime;
                }
            });
        }
        const interval = setInterval(countDown, 1000);
        return () => clearInterval(interval);
    }, [diffTime, onExpired]);

    const duration = dayjs.duration(time || 0);
    const days = duration.get('day');
    const hours = duration.get('hour');
    const minutes = duration.get('minute');
    const seconds = duration.get('second');
    return { seconds, days, minutes, hours };
}
